import React from 'react';
import PropTypes from 'prop-types';
import StyledLoading from './Styles';

const Loading = ({ width, height }) => (
  <StyledLoading width={width} height={height} data-testid="loading" />
);

Loading.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string
};

Loading.defaultProps = {
  width: '100%',
  height: '20px'
};

export default Loading;
